/**
 * Снимок window.WebApp и окружения MAX для отладки (консоль + window.__MAX_WEBAPP_DEBUG__).
 */
import { getMaxInitDataRawString, getMaxInitDataUnsafe } from './maxBridge';

const clonePlain = (obj: unknown): unknown => {
  if (obj === null || obj === undefined) return obj;
  if (typeof obj !== 'object') return obj;
  try {
    return JSON.parse(JSON.stringify(obj));
  } catch {
    return String(obj);
  }
};

export const dumpMaxWebAppToConsole = (): void => {
  if (typeof window === 'undefined') return;

  const wa = (window as unknown as { WebApp?: Record<string, unknown> }).WebApp;

  if (!wa) {
    console.log('[MAX WebApp debug] window.WebApp отсутствует');
    (
      window as unknown as { __MAX_WEBAPP_DEBUG__?: unknown }
    ).__MAX_WEBAPP_DEBUG__ = { error: 'no WebApp' };
    return;
  }

  const ownKeys = Object.getOwnPropertyNames(wa);
  const methodNames: string[] = [];
  const dataFields: Record<string, unknown> = {};

  for (const key of ownKeys) {
    try {
      const desc = Object.getOwnPropertyDescriptor(wa, key);
      const val =
        desc && 'get' in desc && desc.get
          ? (wa as Record<string, unknown>)[key]
          : (wa as Record<string, unknown>)[key];

      if (typeof val === 'function') {
        methodNames.push(key);
        continue;
      }

      if (key === 'initData' && typeof val === 'string') {
        dataFields.initData = {
          length: val.length,
          preview: `${val.slice(0, 160)}${val.length > 160 ? '…' : ''}`,
        };
        continue;
      }

      if (key === 'initDataUnsafe' && val && typeof val === 'object') {
        dataFields.initDataUnsafe = clonePlain(val);
        continue;
      }

      if (key === 'initDataManager' && val && typeof val === 'object') {
        const idm = val as Record<string, unknown>;
        dataFields.initDataManager = {
          keys: Object.getOwnPropertyNames(idm),
          rawInitDataLength:
            typeof idm.rawInitData === 'string'
              ? (idm.rawInitData as string).length
              : undefined,
          rawInitDataPreview:
            typeof idm.rawInitData === 'string'
              ? `${(idm.rawInitData as string).slice(0, 200)}…`
              : undefined,
          initDataUnsafe: clonePlain(idm.initDataUnsafe),
        };
        continue;
      }

      if (val && typeof val === 'object') {
        dataFields[key] = clonePlain(val);
      } else {
        dataFields[key] = val;
      }
    } catch {
      dataFields[key] = '[read error]';
    }
  }

  const resolvedUnsafe = getMaxInitDataUnsafe();
  const resolvedRaw = getMaxInitDataRawString();

  const hash = window.location.hash;
  let hashKeys: string[] = [];
  let webAppDataInHashLength: number | undefined;
  if (hash && hash.length > 1) {
    try {
      const params = new URLSearchParams(hash.slice(1));
      hashKeys = [...params.keys()];
      const wad = params.get('WebAppData');
      webAppDataInHashLength = wad?.length;
    } catch {
      hashKeys = ['(parse error)'];
    }
  }

  const payload = {
    timestamp: new Date().toISOString(),
    /** То, что реально использует приложение (через хелперы) */
    resolvedForApp: {
      initDataRawLength: resolvedRaw?.length,
      initDataRawPreview: resolvedRaw
        ? `${resolvedRaw.slice(0, 200)}${resolvedRaw.length > 200 ? '…' : ''}`
        : undefined,
      initDataUnsafe: clonePlain(resolvedUnsafe),
      start_param: resolvedUnsafe?.start_param,
    },
    location: {
      href: window.location.href,
      search: window.location.search || '(пусто)',
      hashLength: hash.length,
      hashParamKeys: hashKeys,
      webAppDataFragmentLength: webAppDataInHashLength,
    },
    webAppKeys: ownKeys.sort(),
    webAppMethods: methodNames.sort(),
    webAppDataFields: dataFields,
  };

  console.log('[MAX WebApp debug] полный снимок:', payload);
  console.log(
    '[MAX WebApp debug] resolvedForApp (хелперы):',
    payload.resolvedForApp,
  );

  (
    window as unknown as { __MAX_WEBAPP_DEBUG__?: unknown }
  ).__MAX_WEBAPP_DEBUG__ = payload;
};
